import React from "react";
import Icon from "../../../components/AppIcon";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const QuickStatsPanel = ({ stats }) => {
  const { t } = useTranslation();

  const { statistics } = useSelector((state) => state.general);

  const statCards = [
    {
      title: t("totalProducts"),
      value: statistics?.products_count,
      icon: "Package",
      color: "primary",
      change: t("changeThisMonth"),
    },
    {
      title: t("lowStockItems"),
      value:statistics?.products_stock_less_than_10,
      icon: "AlertTriangle",
      color: "warning",
      change: t("changeNeedAttention"),
    },
    {
      title: t("outOfStock"),
      value: statistics?.products_out_of_stock,
      icon: "AlertCircle",
      color: "error",
      change: t("changeRestockNeeded"),
    },
    {
      title: t("categories"),
      value: statistics.categories_count,
      icon: "Tags",
      color: "accent",
      change: t("changeActive"),
    },
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case "primary":
        return "bg-primary text-primary-foreground";
      case "warning":
        return "bg-warning text-warning-foreground";
      case "error":
        return "bg-error text-error-foreground";
      case "accent":
        return "bg-accent text-accent-foreground";
      default:
        return "bg-secondary text-secondary-foreground";
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards.map((stat) => (
        <div
          key={stat.title}
          className="bg-white rounded-lg border border-border shadow-elevation-1 p-4"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">{stat.title}</p>
              <p className="text-2xl font-bold text-foreground">{stat.value}</p>
              <p className="text-xs text-muted-foreground mt-1">
                {stat.change}
              </p>
            </div>
            <div
              className={`w-12 h-12 rounded-md flex items-center justify-center ${getColorClasses(
                stat.color
              )}`}
            >
              <Icon name={stat.icon} size={24} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsPanel;
